/**
 * © 2025 Little Shilling, Inc.
 * Shon Little
 * Created: 2025-07-24
 */

// Add third-party dependencies.
import { Box, Container, Typography, Button } from '@mui/material';
import { Close } from '@mui/icons-material';

// Add local dependencies.
import TermsContent from './TermsContent';

/**
 * Terms of Service page component.
 * @example
 * return <Terms />
 * @returns {React.ReactElement} The Terms of Service page component.
 */
const Terms: React.FC = () => {
  const handleClose = () => {
    window.close();
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Button
          startIcon={<Close />}
          onClick={handleClose}
          variant="outlined"
          sx={{ mb: 2 }}
        >
          Close
        </Button>
        <Typography variant="h3" component="h1" gutterBottom>
          Terms of Service
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Last updated: {new Date().toLocaleDateString()}
        </Typography>
      </Box>

      <TermsContent />
    </Container>
  );
};

export default Terms;
